import { Result } from '@wanjianshi/admin-ui';
import { Navigate, Route, Routes } from 'react-router-dom';
import { AdminLayout } from '@/layouts/AdminLayout';
import { LoginPage } from '@/pages/LoginPage';
import { AuthGuard } from './guards';
import { PermissionRoute } from '@/components/PermissionRoute';
import { adminRoutes } from './routes';

export function AppRouter() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/403" element={<Result status="403" title="403" subTitle="无权访问" />} />
      <Route
        element={<AuthGuard><AdminLayout /></AuthGuard>}
      >
        {adminRoutes.map(route => (
          <Route
            key={route.path}
            path={route.path}
            element={<PermissionRoute permission={route.permission}>{route.element}</PermissionRoute>}
          />
        ))}
        <Route path="/404" element={<Result status="404" title="404" subTitle="页面不存在" />} />
        <Route path="*" element={<Navigate to="/404" replace />} />
      </Route>
    </Routes>
  );
}
